/* eslint-disable camelcase */
/**
 *  Do not edit this file! It is autogenerated from the harmony composerasdfsad
 */
import {
  withLayout,
  withLayoutAccordion,

} from '@thd-olt-component-react/fusion-utils';

import { PIPRedirector }
from '@thd-nucleus/app-render';

import { ProductMetadata }
from '@thd-olt-component-react/metadata';

import { PIPStickyNav }
from '@thd-olt-component-react/sticky-nav';

import { Breadcrumbs }
from '@thd-olt-component-react/breadcrumbs';

import { ProductInfoBar }
from '@thd-olt-component-react/product-info-bar';

import { DynamicRecsWrapperPip, RecentlyViewedWrapper }
from '@thd-olt-component-react/thd-recs-containers';

import { Discontinued }
from '@thd-olt-component-react/discontinued';

import { PIPProductDetails }
from '@thd-olt-component-react/product-details';

import { MediaGalleryWithHotspotsDesktop }
from '@thd-olt-component-react/media-gallery';

import { PIPSharebelt }
from '@thd-olt-component-react/thd-sharebelt';

import { Avataar, RoomVo, RoomVoInspire }
from '@thd-olt-component-react/augmented-reality';

import { ProductPageEventCountdownTimer }
from '@thd-olt-component-react/event-countdown-timer';

import { PIPPriceClearanceWrapper }
from '@thd-olt-component-react/price';

import { Promotion }
from '@thd-olt-component-react/promotion';

import { ConsumerCardMessaging }
from '@thd-olt-component-react/consumer-card-messaging';

import { PromotionProductsAnchor }
from '@thd-olt-component-react/promotion-products';

import { PIPSalientPoints }
from '@thd-olt-component-react/salient-points';

import { AisleBay }
from '@thd-olt-component-react/aisle-bay';

import { ConfiguratorAndPipFlipLayout }
from '@thd-olt-component-react/product-configurator';

import { SuperSku }
from '@thd-olt-component-react/super-sku';

import { FitCompatibility }
from '@thd-olt-component-react/fit-compatibility';

import { MajorApplianceBuyBox }
from '@thd-olt-component-react/buybox';

import { GlobalCustomConfigurator }
from '@thd-olt-component-react/global-custom-configurator';

import { CompatibleAccessories }
from '@thd-olt-component-react/compatible-accessories';

import { BundlePmvFbtLayoutMa }
from '@thd-olt-component-react/bundle-mini';

import { ProductOverviewAccordionTitle }
from '@thd-olt-component-react/product-overview';

import { SpecificationsAccordionTitle }
from '@thd-olt-component-react/specifications';

import { QuestionsAndAnswersAccordionTitle }
from '@thd-olt-component-react/questions-and-answers';

import { RatingsAndReviewsAccordionTitle }
from '@thd-olt-component-react/ratings-and-reviews';

import { BazaarVoiceCarousel }
from '@thd-olt-component-react/social-media-container';

import { SponsoredPipBanner }
from '@thd-olt-component-react/sponsored-content';

import { WhatWeOffer }
from '@thd-olt-component-react/what-we-offer';

import { DeliveryAndInstallation }
from '@thd-olt-component-react/delivery-and-installation';

import { RetailMediaCarouselFusionPIP }
from '@thd-olt-component-react/retail-media-pla-sponsored-placements';

import { RelatedSearch, PopularVariations }
from '@thd-olt-component-react/related-search';

export { PIPRedirector };

export { ProductMetadata };

export { PIPStickyNav };

export { Breadcrumbs };

export { ProductInfoBar };

export { DynamicRecsWrapperPip };

export { Discontinued };

export { PIPProductDetails };

export { MediaGalleryWithHotspotsDesktop };

export { PIPSharebelt };

export { Avataar };

export { RoomVo };

export { ProductPageEventCountdownTimer };

export { PIPPriceClearanceWrapper };

export { Promotion };

export { ConsumerCardMessaging };

export { PromotionProductsAnchor };

export { PIPSalientPoints };

export { AisleBay };

export { ConfiguratorAndPipFlipLayout };

export { SuperSku };

export { FitCompatibility };

export { MajorApplianceBuyBox };

export { GlobalCustomConfigurator };

export { CompatibleAccessories };

export { BundlePmvFbtLayoutMa };

export { ProductOverviewAccordionTitle };

export { SpecificationsAccordionTitle };

export { QuestionsAndAnswersAccordionTitle };

export { RatingsAndReviewsAccordionTitle };

export { BazaarVoiceCarousel };

export { RoomVoInspire };

export { SponsoredPipBanner };

export { WhatWeOffer };

export { DeliveryAndInstallation };

export { RetailMediaCarouselFusionPIP };

export { RecentlyViewedWrapper };

export { RelatedSearch };

export { PopularVariations };

const SlotA1 = withLayout(
  [

    PIPRedirector,

  ],

);

const SlotA2 = withLayout(
  [

    ProductMetadata,

  ],

);

const SlotA3 = withLayout(
  [

    PIPStickyNav,

  ],

);

const SlotB1 = withLayout(
  [

    Breadcrumbs,

  ],

);

const SlotC1 = withLayout(
  [

    ProductInfoBar,

  ],

);

const SlotD1 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotD2 = withLayout(
  [

    Discontinued,

  ],

);

const SlotE1 = withLayout(
  [

    PIPProductDetails,

  ],

);

const SlotE2 = withLayout(
  [

    MediaGalleryWithHotspotsDesktop,

  ],

);

const SlotE3 = withLayout(
  [

    PIPSharebelt,

  ],

);

const SlotE4 = withLayout(
  [

    Avataar,

  ],

);

const SlotE5 = withLayout(
  [

    RoomVo,

  ],

);

const SlotF1 = withLayout(
  [

    ProductPageEventCountdownTimer,

  ],

);

const SlotF2 = withLayout(
  [

    PIPPriceClearanceWrapper,

  ],

);

const SlotF3 = withLayout(
  [

    Promotion,

  ],

);

const SlotF4 = withLayout(
  [

    ConsumerCardMessaging,

  ],

);

const SlotF5 = withLayout(
  [

    PromotionProductsAnchor,

  ],

);

const SlotF6 = withLayout(
  [

    PIPSalientPoints,

  ],

);

const SlotF7 = withLayout(
  [

    AisleBay,

  ],

);

const SlotF8 = withLayout(
  [

    ConfiguratorAndPipFlipLayout,

  ],

);

const SlotF9 = withLayout(
  [

    SuperSku,

  ],

);

const SlotF10 = withLayout(
  [

    FitCompatibility,

  ],

);

const SlotF11 = withLayout(
  [

    MajorApplianceBuyBox,

  ],

);

const SlotF12 = withLayout(
  [

    GlobalCustomConfigurator,

  ],

);

const SlotF13 = withLayout(
  [

    CompatibleAccessories,

  ],

);

const SlotG1 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotG2 = withLayout(
  [

    BundlePmvFbtLayoutMa,

  ],

);

const SlotG6 = withLayout(
  [

    BazaarVoiceCarousel,

  ],

);

const SlotG7 = withLayout(
  [

    RoomVoInspire,

  ],

);

const SlotG8 = withLayout(
  [

    SponsoredPipBanner,

  ],

);

const SlotG9 = withLayout(
  [

    WhatWeOffer,

  ],

);

const SlotG10 = withLayout(
  [

    DeliveryAndInstallation,

  ],

);

const SlotG11 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotG12 = withLayout(
  [

    RetailMediaCarouselFusionPIP,

  ],

);

const SlotG14 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotG15 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotG16 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotG17 = withLayout(
  [

    RecentlyViewedWrapper,

  ],

);

const SlotG18 = withLayout(
  [

    RelatedSearch,

  ],

);

const SlotG19 = withLayout(
  [

    PopularVariations,

  ],

);

const ssr = typeof window === 'undefined';

const SlotG3Index0DataModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/magic-apron'))
    .BotPrompt
  : {};

const SlotG4Index0DataModelK0 = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-overview'))
    .ProductOverviewAccordionTitle
  : {};

const SlotG4Index0DataModelBodyK0 = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-overview'))
    .ProductOverviewAccordionBody
  : {};

const SlotG4Index1DataModelK0 = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/specifications'))
    .SpecificationsAccordionTitle
  : {};

const SlotG4Index1DataModelBodyK0 = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/specifications'))
    .SpecificationsWithKPFAccordionBody
  : {};

const SlotG4Index2DataModelK0 = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/questions-and-answers'))
    .QuestionsAndAnswersAccordionTitle
  : {};

const SlotG4Index2DataModelBodyK0 = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/questions-and-answers'))
    .QuestionsAndAnswersAccordionBody
  : {};

const SlotG4Index3DataModelK0 = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/ratings-and-reviews'))
    .RatingsAndReviewsAccordionTitle
  : {};

const SlotG4Index3DataModelBodyK0 = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/ratings-and-reviews'))
    .RatingsAndReviewsAccordionBody
  : {};

const SlotG5Index0DataModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/magic-apron'))
    .BotPrompt
  : {};

const SlotG13Index0DataModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/feature-based-recommendations'))
    .FeatureBasedRecommendationsImporter
  : {};

const SlotG20Index0DataModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/emt-links'))
    .EmtLinks
  : {};

export {

  SlotA1,

  SlotA2,

  SlotA3,

  SlotB1,

  SlotC1,

  SlotD1,

  SlotD2,

  SlotE1,

  SlotE2,

  SlotE3,

  SlotE4,

  SlotE5,

  SlotF1,

  SlotF2,

  SlotF3,

  SlotF4,

  SlotF5,

  SlotF6,

  SlotF7,

  SlotF8,

  SlotF9,

  SlotF10,

  SlotF11,

  SlotF12,

  SlotF13,

  SlotG1,

  SlotG2,

  SlotG6,

  SlotG7,

  SlotG8,

  SlotG9,

  SlotG10,

  SlotG11,

  SlotG12,

  SlotG14,

  SlotG15,

  SlotG16,

  SlotG17,

  SlotG18,

  SlotG19,

  SlotG3Index0DataModel,

  SlotG4Index0DataModelK0,

  SlotG4Index0DataModelBodyK0,

  SlotG4Index1DataModelK0,

  SlotG4Index1DataModelBodyK0,

  SlotG4Index2DataModelK0,

  SlotG4Index2DataModelBodyK0,

  SlotG4Index3DataModelK0,

  SlotG4Index3DataModelBodyK0,

  SlotG5Index0DataModel,

  SlotG13Index0DataModel,

  SlotG20Index0DataModel,

};
